import React from "react";
import { Icons } from "./Icons";

export const Logo = ({ size = "lg" } = {}) => {
  // The provided logo image is a wide lockup (icon + wordmark).
  // Use height-based sizing so it doesn't get squeezed into a square.
  const heightClass =
    size === "sm"
      ? "h-8"
      : size === "md"
        ? "h-10"
        : size === "xl"
          ? "h-16"
          : "h-12"; // lg default

  return (
    <div className="flex items-center cursor-pointer group select-none">
      <img
        src="/1000115788.png"
        alt="Company logo"
        className={`${heightClass} w-auto max-w-[220px] object-contain transition-transform duration-300 group-hover:scale-[1.03]`}
      />
    </div>
  );
};

export const FeatureCard = ({ icon, title, desc, color }) => (
  <div className="p-8 rounded-[2rem] bg-white border-2 border-slate-100/80 hover:border-blue-100 hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group h-full flex flex-col">
    <div
      className={`w-14 h-14 rounded-2xl ${color} flex items-center justify-center mb-6 shadow-lg transition-transform duration-300 group-hover:scale-110`}
    >
      {icon}
    </div>
    <h3 className="text-xl font-extrabold text-slate-900 mb-3">{title}</h3>
    <p className="text-slate-500 leading-relaxed font-medium">{desc}</p>
  </div>
);

export const MiniFeature = ({ icon, label }) => (
  <div className="flex items-center gap-3 py-3 px-6 rounded-full bg-white border-2 border-slate-100 shadow-sm hover:shadow-md hover:border-blue-200 transition cursor-default whitespace-nowrap">
    <span className="text-2xl">{icon}</span>
    <span className="text-sm font-bold text-slate-700">{label}</span>
  </div>
);

export const FlipCard = ({ data }) => (
  <div className="flip-card-container h-[320px] bg-transparent cursor-pointer">
    <div className="flip-card-inner">
      <div className="flip-card-front bg-white/[0.08] backdrop-blur-lg p-8 rounded-3xl border border-white/10 flex flex-col shadow-xl">
        <div className="flex gap-1 mb-6">
          {[1, 2, 3, 4, 5].map((i) => (
            <Icons.Star key={i} />
          ))}
        </div>
        <p className="text-slate-200 text-lg font-medium italic mb-6 flex-grow">
          "{data.frontText}"
        </p>
        <div className="flex items-center gap-4">
          <img
            src={data.img}
            alt={data.name}
            className="w-12 h-12 rounded-full object-cover border-2 border-slate-700/50"
          />
          <div className="text-left">
            <h4 className="font-bold text-white">{data.name}</h4>
            <p className="text-blue-400 text-sm font-semibold">{data.role}</p>
          </div>
        </div>
      </div>
      <div className="flip-card-back bg-gradient-to-br from-blue-900 to-slate-900 p-8 rounded-3xl border border-blue-500/30 flex flex-col shadow-xl">
        <h4 className="text-sm font-bold text-blue-400 uppercase tracking-widest mb-6 text-center">
          Life Transformation
        </h4>
        <div className="space-y-6 flex-grow text-left">
          <div>
            <div className="flex items-center gap-2 text-red-400 text-sm font-bold mb-1">
              <span>❌</span> Before
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              {data.before}
            </p>
          </div>
          <div className="w-full h-[1px] bg-slate-700/50"></div>
          <div>
            <div className="flex items-center gap-2 text-green-400 text-sm font-bold mb-1">
              <span>✅</span> After
            </div>
            <p className="text-slate-300 text-sm leading-relaxed">
              {data.after}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);
